"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.calculateProgressArcPath = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _stencilReactThemeDefault = require("@amzn/stencil-react-theme-default");
var _screenReaderOnly = require("../screen-reader-only");
var _utils = require("../utils");
var _helperFunctions = require("./helperFunctions");
var _react2 = require("@emotion/react");
const calculateProgressArcPath = _ref => {
  let {
    progress,
    size,
    start,
    strokeWidth,
    color,
    opacity
  } = _ref;
  const deltaTheta = progress * 360;
  const cx = size / 2;
  const cy = size / 2;
  const startAngle = start * 360;
  const theta1 = startAngle + 90;
  const theta2 = startAngle + deltaTheta + 90;
  const r = cx - strokeWidth / 2;
  const x1 = cx - Math.cos(theta1 * Math.PI / 180) * r;
  const y1 = cy - Math.sin(theta1 * Math.PI / 180) * r;
  const x2 = cx - Math.cos(theta2 * Math.PI / 180) * r;
  const y2 = cy - Math.sin(theta2 * Math.PI / 180) * r;
  return progress < 0.0001 || progress > 0.9999 ? (0, _react2.jsx)("circle", {
    cx: cx,
    cy: cy,
    r: r,
    strokeWidth: "".concat(strokeWidth, "px"),
    stroke: (0, _stencilReactThemeDefault.colorPropAdapter)(color) || color,
    opacity: progress <= 0 ? opacity : 1,
    fill: "none"
  }) : [(0, _react2.jsx)("path", {
    key: "path0",
    d: "M ".concat(x1, " ").concat(y1, "\n        A ").concat(r, " ").concat(r, ", 0, ").concat(deltaTheta < 180 ? "0, 1," : "1, 1,", " ").concat(x2, " ").concat(y2),
    strokeWidth: "".concat(strokeWidth, "px"),
    stroke: (0, _stencilReactThemeDefault.colorPropAdapter)(color) || color,
    fill: "none"
  }), (0, _react2.jsx)("path", {
    key: "path1",
    d: "M ".concat(x1, " ").concat(y1, "\n        A ").concat(r, " ").concat(r, ", 0, ").concat(deltaTheta < 180 ? '1, 0,' : '0, 0,', " ").concat(x2, " ").concat(y2),
    strokeWidth: "".concat(strokeWidth, "px"),
    stroke: (0, _stencilReactThemeDefault.colorPropAdapter)(color) || color,
    opacity: opacity,
    fill: "none"
  })];
};
exports.calculateProgressArcPath = calculateProgressArcPath;
const ProgressArcBase = _ref2 => {
  let {
    size = 26,
    start = 0,
    progress = 0.66666,
    color = 'currentColor',
    opacity = 0.5,
    strokeWidth = 2,
    margin = 0,
    getAriaLabelForProgress = _helperFunctions.buildDefaultAriaLabelForProgress,
    'aria-hidden': ariaHidden = false,
    ...outerProps
  } = _ref2;
  const path = calculateProgressArcPath({
    progress,
    size,
    start,
    strokeWidth,
    color,
    opacity
  });
  return (0, _react2.jsx)(_react.default.Fragment, null, (0, _react2.jsx)("svg", (0, _extends2.default)({
    width: size,
    height: size,
    style: {
      margin
    },
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    focusable: "false"
  }, outerProps), path), ariaHidden ? undefined : (0, _react2.jsx)(_screenReaderOnly.ScreenReaderOnly, null, getAriaLabelForProgress(progress)));
};
ProgressArcBase.defaultProps = {
  size: 26,
  start: 0,
  progress: 0.66666,
  color: 'currentColor',
  opacity: 0.5,
  strokeWidth: 2,
  margin: 0,
  getAriaLabelForProgress: _helperFunctions.buildDefaultAriaLabelForProgress,
  'aria-hidden': false
};
const ProgressArcBaseWithDocs = (0, _stencilReactDesc.describe)(ProgressArcBase).description('Circular progress bar.');
ProgressArcBaseWithDocs.propTypes = {
  size: _stencilReactDesc.PropTypes.number.description('Diameter of the arc, in pixels.'),
  start: _stencilReactDesc.PropTypes.number.description('Angle from the top of the arc to start the colored segment, in degrees.'),
  progress: _stencilReactDesc.PropTypes.number.description('Amount of the arc to fill with the colored segment, as a value between 0 and 1.'),
  color: _stencilReactDesc.PropTypes.string.description('Color to use for the colored segment.'),
  opacity: _stencilReactDesc.PropTypes.number.description('Opacity of the unfilled section of the arc, as a value between 0 and 1.'),
  strokeWidth: _stencilReactDesc.PropTypes.number.description('Width of the arc stroke, in pixels.'),
  margin: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.number]).description('Margin around the entire element.'),
  getAriaLabelForProgress: _stencilReactDesc.PropTypes.func.description('Function used to generate a screen reader only message representing progress. When not set, defaults to a function returning a percentage corresponding to the current progress (e.g. 0.66 => 66%).').format('(progress: number) => string'),
  'aria-hidden': _stencilReactDesc.PropTypes.bool.description("Sets the 'aria-hidden' attribute in the DOM. If true, it's assumed ProgressArc is used in conjunction with accessible content representing progress.")
};
const ProgressArc = (0, _utils.withTestAttributes)({
  component: 'StencilReactProgressArc'
})(ProgressArcBaseWithDocs);
var _default = exports.default = ProgressArc;